export enum PaymentTypes {
    Deposit = 'Deposit',
    Rest = 'Rest',
    Complete = 'Complete'
}